import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {map, mergeMap, catchError} from 'rxjs/operators';
import {of} from 'rxjs';
import {ApiService} from '../../../core/http/api.service';
import {LoadPropertyUploadsActionParams} from '../../models/property.model';
import {GetPropertyUploadsResponseModel} from '../../../shared/models/uploads/property-uploads.models';
import { PropertyUploadActions } from '../../actions/property/property-uploads.actions';

@Injectable()
export class PropertyUploadsEffects {

   loadPropertyUploads$ = createEffect(() => this.actions$
    .pipe(
      ofType(PropertyUploadActions.loadPropertyUploads),
      mergeMap(
        (data: LoadPropertyUploadsActionParams) => this.api.Uploads.getPropertyUploads(data.propertyId, data.params)
          .pipe(
            map((response: GetPropertyUploadsResponseModel) => PropertyUploadActions.loadPropertyUploadsSuccess(response)),
            catchError(error => of(PropertyUploadActions.loadPropertyUploadsFailure(error)))
          )
      )
    ));

  constructor(
    private actions$: Actions,
    private api: ApiService
  ) {}
}
